import React from 'react';
import PluginComponent from '../plugin-component';

class MediaHtmlTitle extends PluginComponent {
    constructor(props) {
        super(props);
        this.state = {
            title: ""
        }
        this.subscriptions = [];
        require('./media-html-title.scss');
        //console.log("[MediaHtmlTitle] props:", props);
    }
    show() {
        let { player: amp } = this.props;
        this.setState({
            title: amp.media.title
        })
    }
    hide() {
        this.setState({
            title: ""
        })
    }

    pluginComponentDidMount() {
        if (this.props.config.show === true) {
            let { player: amp } = this.props;
            let mediachange$ = amp.AmpEventsSources["mediachange"].subscribe(eventData => {
                this.show();
            });
            let play$ = amp.AmpEventsSources["playing"].subscribe(eventData => {
                this.hide();
            });
            let pause$ = amp.AmpEventsSources["paused"].subscribe(eventData => {
                this.show();
            });

            this.subscriptions.push(mediachange$);
            this.subscriptions.push(play$);
            this.subscriptions.push(pause$);
        }
    }

    render() {
        if (this.state.title.trim() == "") {
            return null;
        }

        return (
            <div className="media-html-title-module">
                <div className="media-title">
                    <span dangerouslySetInnerHTML={ { __html: this.state.title } }></span>
                </div>
            </div>
        )
    }
    static get containerClass() {
        return "media-html-title-plugin-container";
    }

}
window.akamai.amp.AMP.registerPlugin("MediaHtmlTitle", MediaHtmlTitle.create.bind(MediaHtmlTitle));

export default MediaHtmlTitle;